module.exports = require("qrcode.react");